export default __webpack_public_path__ + "static/media/tennis.9b887c17.png";